import CheckoutPaymentSubscribtionWrapper from './CheckoutPaymentSubscribtionWrapper.component';

export default CheckoutPaymentSubscribtionWrapper;